import { render, staticRenderFns } from "./order-modal.vue?vue&type=template&id=fb95b820&"
import script from "./order-modal.vue?vue&type=script&lang=js&"
export * from "./order-modal.vue?vue&type=script&lang=js&"
import style0 from "./order-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb95b820')) {
      api.createRecord('fb95b820', component.options)
    } else {
      api.reload('fb95b820', component.options)
    }
    module.hot.accept("./order-modal.vue?vue&type=template&id=fb95b820&", function () {
      api.rerender('fb95b820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/order-modal.vue"
export default component.exports